import commonConfig from './tailwind-common.config.js';
import fluid, { extract, screens, fontSize } from 'fluid-tailwind';

export default {
    ...commonConfig,
    content: {
        files: [
            'public/classes/**/*.php',
            'public/controllers/**/*.php',
            'public/functions/**/*.php',
            'public/templates/**/*.php',
            'ecmascript/**/*.js',
        ],
        extract,
    },
    theme: {
        ...commonConfig.theme,
        screens: {
            ...screens,
            '3xl': '120rem',
        },
        fontSize,
        fontFamily: {
            body: ['Helvetica', 'Arial', 'sans-serif'],
            heading: ['industry', 'sans-serif'],
        },
    },
    plugins: [
        ...commonConfig.plugins,
        fluid,
    ],
};

